// Updated API Base URL (Relative for Proxy/Nginx)
export const API_BASE_URL = "/api";

// Default Tenant ID for testing if not provided in URL
export const TEST_TENANT_ID = "a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11";

export const IS_DEMO_MODE = false;

// Fallback images
export const PLACEHOLDER_IMAGE = "https://placehold.co/600x600/f3f4f6/9ca3af?text=Sem+Imagem";
